import React, { useEffect, useState, useMemo } from 'react'

/**
 * Rulers Component
 * Fixed rulers that don't scroll with the workspace content
 * Top ruler is completely fixed, left ruler scrolls vertically with content
 */
const Rulers = ({
  zoomLevel,
  currentPageIndex,
  template_content,
  workspaceSize,
  scrollPosition = { x: 0, y: 0 },
  showRulers = true
}) => {
  // Don't render if rulers are hidden
  if (!showRulers) {
    return null
  }
  const [rulerStep, setRulerStep] = useState(50)

  // Update ruler step based on zoom level for better label visibility
  // useEffect(() => {
  //   const scale = zoomLevel / 100
  //   setRulerStep(step)
  // }, [zoomLevel])

  // Memoize calculations for better performance
  const rulerData = useMemo(() => {
    const scale = zoomLevel / 100
    const stepPx = rulerStep * scale
    const currentPage = template_content?.pages?.[currentPageIndex]
    const pageWidth = (currentPage?.page_config?.width || 800) * scale
    const pageHeight = (currentPage?.page_config?.height || 600) * scale
    const workspaceWidth = workspaceSize?.width || 0
    const workspaceHeight = workspaceSize?.height || 0

    // Page positioning logic - centered horizontally, with top margins
    const pageX = Math.max(0, (workspaceWidth - pageWidth - 20) / 2) // Account for left ruler
    const firstPageMargin = 200
    const subsequentPageMargin = 100
    const pageY = (currentPageIndex === 0 ? firstPageMargin : firstPageMargin + subsequentPageMargin)

    return {
      scale,
      stepPx,
      pageWidth,
      pageHeight,
      workspaceWidth,
      workspaceHeight,
      pageX,
      pageY
    }
  }, [zoomLevel, rulerStep, template_content, currentPageIndex, workspaceSize])

  const { pageX, pageY, pageWidth, pageHeight, workspaceHeight, workspaceWidth } = rulerData

  return (
    <>
      {/* Horizontal Ruler */}
      <div className="absolute top-0 left-5 right-0 h-5 bg-gray-300 overflow-hidden pointer-events-none border-b border-gray-400">
        {/* Ruler lines and labels */}
        {/* <div> workspace Width: {workspaceWidth} </div> */}
        {/* <div> workspace Height: {workspaceSize.height} </div> */}
        {Array.from({ length: Math.ceil(workspaceWidth / 50) + 1 }, (_, i) => {
          const x = i * 50
          const value = i * 50
          return (
            <div key={`ruler-${i}`} className="absolute" style={{ left: `${x}px` }}>
              {/* Vertical line */}
              <div 
                className="absolute bg-gray-600"
                style={{
                  width: '1px',
                  height: '100%',
                  left: '0px'
                }}
              />
              {/* Label */}
              <div 
                className="absolute text-xs font-bold text-gray-800"
                style={{
                  left: '2px',
                  top: '1px',
                  fontSize: '8px'
                }}
              >
                {value}
              </div>
            </div>
          )
        })}
      </div>

      {/* Vertical Ruler */}
      <div
        className="absolute top-5 left-0 w-5 bg-gray-300 pointer-events-none border-r border-gray-400"
        style={{
          height: `${workspaceHeight - 20}px`,
          overflow: 'hidden'
        }}
      >
        {/* Ruler lines and labels */}
        {Array.from({ length: Math.ceil(workspaceHeight / 50) + 1 }, (_, i) => {
          const y = i * 50
          const value = i * 50
          return (
            <div key={`v-ruler-${i}`} className="absolute" style={{ top: `${y}px` }}>
              {/* Horizontal line */}
              <div 
                className="absolute bg-gray-600"
                style={{
                  height: '1px',
                  width: '100%',
                  top: '0px'
                }}
              />
              {/* Label */}
              <div 
                className="absolute text-xs font-bold text-gray-800"
                style={{
                  left: '10px',
                  top: '2px',
                  fontSize: '7px',
                  transform: 'rotate(-90deg)',
                  transformOrigin: 'left center'
                }}
              >
                {value}
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Rulers
